"use client";
import React, { createContext, useState, useContext } from "react";
import { BASE_URL } from "../config/apiConfig";
import { useNavigate } from "react-router-dom";

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const navigate = useNavigate();

  const [user, setUser] = useState(
    JSON.parse(localStorage.getItem("auth_user")) || null
  );
  const [token, setToken] = useState(localStorage.getItem("auth_token") || null);

  // ✅ Signup
  const signup = async (data) => {
    try {
      const res = await fetch(`${BASE_URL}/users`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify({
          first_name: data.firstName,
          last_name: data.lastName,
          email: data.email,
          mobile: data.phone,
          password: data.password,
        }),
      });

      return await res.json();
    } catch (error) {
      console.error("Signup error:", error);
      return { status: 400, message: "Something went wrong" };
    }
  };

  // ✅ Login
  const login = async (email, password) => {
  try {
    const res = await fetch(`${BASE_URL}/login`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify({ email, password }),
    });

    const data = await res.json().catch(() => null);

    // ✅ Successful login
    if (res.ok && data?.status === 200) {
      setUser(data.data);
      setToken(data.token);

      localStorage.setItem("auth_token", data.token);
      localStorage.setItem("auth_user", JSON.stringify(data.data));
      localStorage.setItem("user_id", data.data.id);
      localStorage.setItem("uemail", data.data.email);
      localStorage.setItem("sub_id", data.data.subscription?.id || "");
      localStorage.setItem("plan_id", data.data.subscription?.plan_id || "");

      return { success: true, message: data.message };
    }

    // ✅ Handle 403 (inactive user)
    if (res.status === 403) {
      return { success: false, message: data?.message || "User account is not active" };
    }

    // ✅ Handle validation errors
    if (data?.messages?.error) {
      return { success: false, message: "Invalid username or password" };
    }

    return { success: false, message: "Login failed" };
  } catch (error) {
    console.error("Login error:", error);
    return { success: false, message: "Something went wrong" };
  }
};


  // ✅ Logout
  const logout = () => {
    setUser(null);
    setToken(null);
    localStorage.removeItem("auth_token");
    localStorage.removeItem("auth_user");
    localStorage.removeItem("user_id");
    localStorage.removeItem("sub_id");

    navigate("/login", { replace: true });
  };

  return (
    <AuthContext.Provider value={{ user, token, signup, login, logout, setUser, setToken }}>
      {children}
    </AuthContext.Provider>
  );
};

// ✅ Custom hook for easy use in other files
export const useAuth = () => useContext(AuthContext);
